import { HcCompsIcon } from '@hcs/design-system';
import { AppSlugs } from '@hcs/types';
import { AppConfig } from '@hcs/types';

export const APP_CONFIG_CANARY_ADMIN: AppConfig = {
  name: 'Canary Admin',
  applicationKey: 'internal-canary-admin',
  type: 'internal',
  appSlugForEngagement: AppSlugs.CanaryAdmin,
  rootPath: '/canary-admin',
  Icon: HcCompsIcon,
  descriptionLong: 'HouseCanary Staff User and Platform Permissions Management',
  descriptionShort: 'HouseCanary Staff Management',
};

export const VIEW_PATHS_CANARY_ADMIN = {
  USERS: 'users',
  USER: ':userId',
  USER_INTERNAL_PERMISSIONS: 'internal-permissions',
  USER_LOGIN_AS: 'login-as',
} as const;
